var exports = {
  "N": "idle__PIhf9I",
  "K": "copilotRun__vT8vns",
};

module.exports = exports;
